import Sidebar from "./Sidebar";
import Header from "./Header";

const MainLayout =
({ children }) => {

  return(

    <div className="d-flex">

  <Sidebar />

  <div
    className="flex-grow-1"
    style={{
      background: "#f3f4f6",
      minHeight: "100vh"
    }}
  >
    <Header />

    <div className="p-4">

      {children}

    </div>

  </div>

</div>

  );

};

export default MainLayout;